import Component from "../abstracts/Component";

export default class SortByComponent extends Component {
  get SELECTORS() {
    return {
      main: '[data-sortby]',
      input: '.js-sortby-input',
      activeValue: '.active',
      sortByTrigger:'.js-sortby-trigger'
    }
  }
  
  get CLASSES() {
    return {
      activeClass: 'active',
      layerVisible: 'show',
      layerVisibleReset: 'show-active',
      buttonCloseLayer: 'collapsed'
    }
  }
  
  constructor() {
    super();
    this.main = document.querySelector(this.SELECTORS.main);
    this.trigger = document.querySelector(this.SELECTORS.sortByTrigger);
  }
  
  forceClose() {
    this.main.classList.contains(this.CLASSES.layerVisibleReset) ? this.main.classList.remove(this.CLASSES.layerVisibleReset) : this.main.classList.remove(this.CLASSES.layerVisible);    
    this.trigger.classList.contains(this.CLASSES.buttonCloseLayer) ? this.trigger.classList.remove(this.CLASSES.buttonCloseLayer) : this.trigger.classList.add(this.CLASSES.buttonCloseLayer); 
    this.$emit(this.$customEvents.BACKDROP_EVENTS.hide);
  }   

  bindEvents() {

    this.$on('click.sortBy', ({event}) => {
      let input = event.currentTarget;
      let main = document.querySelector(this.SELECTORS.main);
      let elementActive = main.querySelector(this.SELECTORS.activeValue);

      main.dataset.sortby = input.dataset.value;
      elementActive.classList.remove(this.CLASSES.activeClass);
      event.delegateTarget.parentElement.classList.add(this.CLASSES.activeClass);

      this.$emit(this.$customEvents.SORT_BY_EVENTS.changed, {
        value: input.dataset.value,
        name: input.dataset.sortbyName,
      });
    }, this.SELECTORS.input);
    
  }

  render() {
    if (document.querySelector(this.SELECTORS.main)) {
      this.bindEvents();
    }
  }
}
